"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function SingleStarSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.09094 8.0581L12.3273 6.65078C12.4896 6.59645 12.6 6.44566 12.6 6.2745C12.6 6.1047 12.4896 5.95256 12.3273 5.89822L8.84495 4.74222C8.37046 4.58464 7.99823 4.21244 7.8387 3.73971L6.67837 0.271683C6.62383 0.108673 6.47248 0 6.30068 0C6.13025 0 5.97753 0.108673 5.92436 0.271683L4.76403 3.73971C4.6045 4.21244 4.23227 4.58464 3.75641 4.74222L0.272698 5.89822C0.110443 5.95256 0 6.1047 0 6.2745C0 6.44566 0.110443 6.59645 0.272698 6.65078L3.75641 7.80679C4.23091 7.96573 4.6045 8.33657 4.76267 8.81066L5.923 12.2814C5.97754 12.4431 6.13025 12.5517 6.30068 12.5517C6.47248 12.5517 6.62383 12.4431 6.67837 12.2814L8.09094 8.0581Z", fill: "#A6B8F3" }));
}
function SingleStar(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(SingleStarSvg, Object.assign({}, svgProps)));
}
exports.default = SingleStar;
//# sourceMappingURL=SingleStar.js.map